import config from '../config/kystverket';

export function getMediaUrl(mediaContent, name) {
  if (!mediaContent) return null;
  const url = new URL(mediaContent.url, config.adaptive4Url);
  url.pathname += '/' + (name || mediaContent.name);
  return url.toString();
}
